import { useCallback, useEffect, useState } from 'react';

import { Button, Dialog, Tabs } from '@sayyesschool/frontend/ui-components';

import EnrollmentForm from '@/components/enrollments/enrollment-form';
import LearnerForm from '@/components/learners/learner-form';
import RequestForm from '@/components/requests/request-form';

import styles from './RequestProcessFormDialog.module.scss';

export default function RequestProcessFormDialog({ request, open, onSubmit, onClose }) {
    const [activeTab, setActiveTab] = useState('learner');
    const [learnerData, setLearnerData] = useState(() => {
        const { name, email, phone } = request.contact || {};
        const [firstname, lastname] = name?.split(' ') || [];

        return {
            firstname,
            lastname,
            email,
            phones: phone ? [phone] : ['']
        };
    });
    const [enrollmentData, setEnrollmentData] = useState({});
    const [requestData, setRequestData] = useState(request);

    useEffect(() => {
        if (request.learnerId) {
            setActiveTab('enrollment');
            setLearnerData({});
        }

        setRequestData(request);
    }, [request]);

    const handleSubmit = useCallback(() => {
        const learner = learnerData;
        const enrollment = enrollmentData;
        const request = requestData;

        if (!learner || !enrollment || !request) {
            return;
        }

        onSubmit({ learner, enrollment, request });
    }, [learnerData, enrollmentData, requestData, onSubmit]);

    return (
        <Dialog
            className={styles.root}
            title="Обработка заявки"
            open={open}
            content={<>
                <Tabs
                    value={activeTab}
                    items={[
                        request.learner ? null : {
                            value: 'learner',
                            content: 'Ученик'
                        },
                        {
                            value: 'enrollment',
                            content: 'Обучение'
                        },
                        {
                            value: 'request',
                            content: 'Обращение'
                        }
                    ].filter(Boolean)}
                    onChange={(event, value) => setActiveTab(value)}
                />

                <div className={styles.content}>
                    {activeTab === 'learner' && !request?.learner &&
                        <LearnerForm
                            learner={learnerData}
                            onChange={setLearnerData}
                        />
                    }

                    {activeTab === 'enrollment' &&
                        <EnrollmentForm
                            enrollment={enrollmentData}
                            onChange={setEnrollmentData}
                        />
                    }

                    {activeTab === 'request' &&
                        <RequestForm
                            request={requestData ?? request}
                            onChange={setRequestData}
                        />
                    }
                </div>
            </>}
            actions={[
                <Button
                    key="cancel"
                    type="submit"
                    content="Отменить"
                    variant="plain"
                    onClick={onClose}
                />,

                <Button
                    key="submit"
                    type="button"
                    content="Сохранить"
                    disabled={!learnerData || !enrollmentData || !requestData}
                    onClick={handleSubmit}
                />
            ]}
            scrollableContent={false}
            onClose={onClose}
        />
    );
}